/** Line item ids from cost engine → distinct, saturated hues (pie, bars, export). */
export const LINE_ITEM_COLORS: Record<string, string> = {
  apigw: "#2563eb",
  lambda: "#7c3aed",
  dynamo: "#ea580c",
  s3: "#ca8a04",
  llm: "#059669",
  cw: "#db2777",
  xfer: "#0891b2",
  ec2: "#d97706",
  rds: "#0d9488",
  cloudfront: "#65a30d",
  ec2_spa: "#b45309",
  ec2_app: "#c2410c",
  eks: "#6d28d9",
  vpc_private: "#16a34a",
  route53: "#0e7490",
  alb_waf: "#dc2626",
  guardduty: "#4f46e5",
};
